import { render, staticRenderFns } from "./employeeInteractionBack.vue?vue&type=template&id=ef189650&scoped=true&"
import script from "./employeeInteractionBack.vue?vue&type=script&lang=js&"
export * from "./employeeInteractionBack.vue?vue&type=script&lang=js&"
import style0 from "./employeeInteractionBack.vue?vue&type=style&index=0&id=ef189650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef189650",
  null
  
)

export default component.exports